import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";


interface IPayrollAdjustmentReportHeader {
	setStateRunGetListAPICall: (value: boolean) => void
	departmentsDDL: any;
	teamsDDL: any;
	payPeriodDDLItems: any;
	employeeDDLItems: any;
	payPeriodEndDateDDL: any;
	onPeriodEndDateSelectionChangeHandler: (value: string) => void
}

export const PayrollAdjustmentReportHeader: React.FC<
	IPayrollAdjustmentReportHeader
> = ({ setStateRunGetListAPICall, teamsDDL, payPeriodDDLItems, departmentsDDL, employeeDDLItems , payPeriodEndDateDDL , onPeriodEndDateSelectionChangeHandler}) => {

		const onPayPeriodSelectionChangeHandler = (e: any) => {
		// formMethods.setValue('endDate', undefined)
		onPeriodEndDateSelectionChangeHandler(e.value);
		setStateRunGetListAPICall(false)
	}

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"payPeriod"}
						items={payPeriodDDLItems ?? []}
						selectedItem={"all"}
						label={"Pay Period"}
						testId={"pay-period-ddl"}
						// onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						onSelectionChangeHandler={onPayPeriodSelectionChangeHandler}
						
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>

				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"department"}
						items={departmentsDDL ?? []}
						selectedItem={"all"}
						label={"Department"}
						testId={"department-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"employeeName"}
						items={employeeDDLItems ?? []}
						// selectedItem={"all"}
						label={"Employee Name"}
						testId={"employee-name-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.7, lg: 0.7, xl: 0.7 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", marginTop: "1.4rem", paddingLeft: "2rem" }}>
					<span style={{ height: "10px", width: "10px", background: "rgb(186, 216, 168)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Cash Earnings</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(228, 243, 255)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Non-Cash Earnings</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(255, 228, 248)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Deductions</span>
					<br />
					<span style={{ height: "10px", width: "10px", background: "rgb(248, 255, 188)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
					<span>Non-Cash Dedutions</span>
				</Grid>

				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
						<EnhancedDropDownRHFWithLabel
							selectName={"periodEndDate"}
							items={payPeriodEndDateDDL ?? []}
							selectedItem={"all"}
							label={"End Date"}
							testId={"end-date-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
						<EnhancedDropDownRHFWithLabel
							selectName={"team"}
							items={teamsDDL ?? []}
							selectedItem={"all"}
							label={"Team"}
							testId={"team-ddl"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
						// sx={{
						// 	"& .calenderWrapper": { maxWidth: "300px!important", },
						// }}
					>
						<RHookFormDatePicker
							name="startDate"
							testId="start-date"
							label="Date Range"
							format="M dd, yy"
							onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>
					<Grid
						size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}
						sx={{ maxWidth: "82px", textAlign: "center", paddingTop: "30px" }}
					>
						<span style={{
							fontSize: "0.875rem",
							fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
							fontWeight: 500,
							letterSpacing: "0.00714em",
							color: "rgba(0, 0, 0, 0.6)",
						}}>to</span>
					</Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
						sx={{
							"& .MuiGrid-root .MuiFormLabel-root": { marginTop: "24px!important", },
							// "& .calenderWrapper": { maxWidth: "24px!important", },
						}}
					>
						<RHookFormDatePicker
							name="endDate"
							testId="end-date"
							label=""

							format="M dd, yy"
							onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						/>
					</Grid>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
				</Grid>
			</Grid>
		</>
	);
};


		// <>
		// 	<Grid
		// 		container
		// 		size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
		// 		sx={{
		// 			background: "#fff",
		// 			border: "1px solid #e5e7eb",
		// 			borderBottom: 0,
		// 			borderRadius: "2px 2px 0 0",
		// 			padding: "31px 20px 1rem 20px",
		// 			marginBottom: "0px!important",
		// 		}} columnSpacing={2}>
		// 		<Grid
		// 			size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
		// 			// sx={{ mt: "12px" }}
		// 			sx={{
		// 				color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
		// 				"& .MuiGrid-root": {
		// 					// marginBottom: "-5px!important",

		// 				},
		// 				//  "& .calenderWrapper MuiBox-root":{width:"270px!important"},
		// 			}}>
		// 			<EnhancedDropDownRHFWithLabel
		// 				selectName={"payPeriod"}
		// 				items={payPeriodDDLItems ?? []}
		// 				selectedItem={"all"}
		// 				label={"Pay Period"}
		// 				testId={"pay-period-ddl"}
		// 				onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
		// 			/>
		// 			<EnhancedDropDownRHFWithLabel
		// 				selectName={"endDateValue"}
		// 				items={endDateDDLItems ?? []}
		// 				selectedItem={"all"}
		// 				label={"End Date"}
		// 				testId={"end-date-ddl"}
		// 				onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
		// 			/>
		// 			<EnhancedButtonPrimeReact
		// 				label="Apply Filter"
		// 				raised
		// 				type="submit"
		// 				// onClickHandler={onApplyButtonClickedHandler}
		// 				severity={EnhancedButtonPrimeReactSeverity.Secondary}
		// 			// onClickHandler={() => setStateRunGetListAPICall(true)}
		// 			/>
		// 		</Grid>
		// 		<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>

		// 		<Grid
		// 			size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
		// <EnhancedDropDownRHFWithLabel
		// 	selectName={"department"}
		// 	items={departmentsDDL ?? []}
		// 	selectedItem={"all"}
		// 	label={"Department"}
		// 	testId={"department-ddl"}
		// 	onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
		// />

		// <EnhancedDropDownRHFWithLabel
		// 	selectName={"teams"}
		// 	items={teamsDDL ?? []}
		// 	selectedItem={"all"}
		// 	label={"Team"}
		// 	testId={"team-ddl"}
		// 	onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
		// />
		// 		</Grid>
		// 		<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
		// 			<Grid
		// 			size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
		// <EnhancedDropDownRHFWithLabel
		// 	selectName={"employeeName"}
		// 	items={employeeDDLItems ?? []}
		// 	// selectedItem={"all"}
		// 	label={"Employee Name"}
		// 	testId={"employee-name-ddl"}
		// 	onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
		// />
		// 		</Grid>


		// 		<Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
		// <Grid
		// 	size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
		// 	sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem", marginTop: "1.4rem", paddingLeft: "2rem" }}>


		// 	<span style={{ height: "10px", width: "10px", background: "rgb(186, 216, 168)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
		// 	<span>Cash Earnings</span>
		// 	<br />
		// 	<span style={{ height: "10px", width: "10px", background: "rgb(228, 243, 255)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
		// 	<span>Non-Cash Earnings</span>
		// 	<br />
		// 	<span style={{ height: "10px", width: "10px", background: "rgb(255, 228, 248)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
		// 	<span>Deductions</span>
		// 	<br />
		// 	<span style={{ height: "10px", width: "10px", background: "rgb(248, 255, 188)" }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
		// 	<span>Non-Cash Dedutions</span>


		// </Grid>

		// 	</Grid>

		// </>